import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SearchPage from "@/pages/SearchPage";
import PasswordGate from "@/components/PasswordGate";

function App() {
  return (
    <div className="App dark">
      <PasswordGate>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<SearchPage />} />
          </Routes>
        </BrowserRouter>
      </PasswordGate>
    </div>
  );
}

export default App;
